/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { RUSSIA_TITLE, RUSSIA_DESCRIPTION } from '../../Utils/Constants/SEO';
import ToursResultFunc from '../ToursResult/ToursResultFunc';
import { RUSSIA_NAME } from '../../Utils/Constants/GlobalConstants';
import { getCountry } from '../../Utils/CommonUtils';
import { getCurrentYear } from '../../Utils/DateUtil';

class Oman extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = () => (
    <div>
      <div className="content_block">
        <h1 className="text_h1">{`Туры в Россию из Минска: Ваш Идеальный Маршрут в ${getCurrentYear()} Году`}</h1>
        <h2 className="text_h2">Отдых в России: безграничные возможности</h2>
        <p className="text_p">
          Россия — страна контрастов, где соседствуют многовековая история и
          современные мегаполисы, дикая природа и развитые курорты. Для
          белорусских туристов это направление особенно привлекательно благодаря
          близости географического расположения - добраться проще простого.
        </p>
        <p className="text_p">
          Культурное единство — отсутствие языкового барьера и общие
          исторические корни упрощают адаптацию. Разнообразие ландшафтов - от
          альпийских лугов Кавказа до вулканов Камчатки, от дворцов Петербурга
          до песчаных пляжей Сочи.
        </p>
        <p className="text_p">
          Например, при покупке тура в Дагестан (10 дней) у вас есть возможность
          посещения древнего Дербента, Сулакского каньона (глубочайшего в
          Европе) и горных аулов, сочетая экстрим и культурное погружение.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Когда лучше ехать: сезонность по регионам</h2>
        <p className="text_p">Лето (июнь–август)</p>
        <p className="text_p">
          Карелия — идеальна для сплавов по рекам, посещения Рускеалы и Валаама.
          Температура: +18...+25°C. Черноморское побережье (Сочи, Анапа) —
          пляжный сезон (+28...+32°C).
        </p>
        <p className="text_p">Зима (декабрь–март)</p>
        <p className="text_p">
          Горнолыжные курорты (Домбай, Приэльбрусье) — катание, термальные
          источники.
        </p>
        <p className="text_p">
          Петербург — романтика заснеженных дворцов и новогодних ярмарок.
        </p>
        <p className="text_p">Май/Сентябрь</p>
        <p className="text_p">
          Золотая осень в "Золотом кольце" (Суздаль, Ярославль) или бархатный
          сезон в Калининграде.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Цены на Туры в 2025 Году: Бюджет vs Премиум</h2>
        <p className="text_p">
          Стоимость зависит от направления, туроператора, длительности и уровня
          комфорта. С ценами можно ознакомиться у нас на сайте.
        </p>
        <p className="text_p">Совет: Раннее бронирование экономит до 30%.</p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Виды Отдыха: Чем Заняться в России</h2>
        <p className="text_p">
          Классика: Москва (Кремль, Арбат), Петербург (Эрмитаж, Петергоф),
          "Золотое кольцо".
        </p>
        <p className="text_p">
          Необычное: Дагестан (село-призрак Гамсутль), Камчатка (Долина
          гейзеров).
        </p>
        <p className="text_p">
          Активный отдых: Трекинг в Приэльбрусье или на Алтае. Сплав по рекам
          Карелии — включен в тур "Гранд-тур по Карелии".
        </p>
        <p className="text_p">
          Пляжный релакс: Черное море: Сочи, Анапа, Туапсе.
        </p>
        <p className="text_p">
          Каспийское море: курорты Дагестана (Избербаш, Дербент).
        </p>
        <p className="text_p">Зимние виды: Горные лыжи в Домбае.</p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Топ-10 Достопримечательностей: Must-See</h2>
        <p className="text_p">
          Санкт-Петербург: Эрмитаж, развод мостов, фонтаны Петергофа.
        </p>
        <p className="text_p">
          Озеро Байкал: Кругобайкальская железная дорога, остров Ольхон.
        </p>
        <p className="text_p">
          Москва: Красная площадь, парк "Зарядье", Третьяковская галерея.
        </p>
        <p className="text_p">
          Карелия: Горный парк "Рускеала", водопад Кивач.
        </p>
        <p className="text_p">Калининград: Куршская коса, форт "Дёнхофф".</p>
        <p className="text_p">
          Золотое кольцо: Суздаль (музей деревянного зодчества), Ярославль
          (Спасо-Преображенский монастырь).
        </p>
        <p className="text_p">
          Кавказ: Домбай, Эльбрус, Сулакский каньон (Дагестан).
        </p>
        <p className="text_p">Камчатка: Вулканы, Долина гейзеров.</p>
        <p className="text_p">Сочи: Олимпийский парк, Сочинский дендрарий.</p>
        <p className="text_p">
          Крым: Ливадийский дворец, Ласточкино гнездо (доступно через паром из
          Краснодарского края).
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">
          Заключение: Почему Стоит Выбрать Тур в Россию?
        </h2>
        <p className="text_p">
          Россия предлагает уникальный микс впечатлений за разумные деньги.
          Организовать поездку легко: туроператоры предлагают готовые решения с
          трансферами, экскурсиями и проживанием. Для вдохновения изучите
          горящие туры на сайте tourhunter.by. Собирайте чемоданы —
          величественная Россия ждет!
        </p>
      </div>
    </div>
  );

  render() {
    const text = this.getText();
    return (
      <div className="content">
        <Helmet>
          <title>{RUSSIA_TITLE}</title>
          <meta name="description" content={RUSSIA_DESCRIPTION} />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/russia/" />
          <meta property="og:title" content={RUSSIA_TITLE} />
          <meta property="og:description" content={RUSSIA_DESCRIPTION} />

          <link rel="canonical" href="https://tourhunter.by/russia/" />
        </Helmet>
        <ToursResultFunc countryFilter={getCountry(RUSSIA_NAME)} text={text} />
      </div>
    );
  }
}

export default Oman;
